var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-row align-items-end" },
    [
      _vm.$mods.billing.access_all_families &&
      _vm.can(_vm.PERMISSIONS.ACCESS_ALL_FAMILIES)
        ? _c(
            "div",
            { staticClass: "col-md-3" },
            [
              _c("form-select", {
                attrs: {
                  label: _vm.Lang.get("messages.branch"),
                  options: _vm.SchoolsForSelect,
                  name: "school",
                  model: _vm.localFilters,
                  "label-field": "name",
                  "value-field": "id",
                  reduce: (value) => value.id,
                  multiple: _vm.isSuperadminLoggedSchool,
                  selectAllOption: false,
                },
                on: {
                  change: (e) => {
                    _vm.loadAllDataToSelects()
                    _vm.updateSelectedNames()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAcademicYear
        ? _c(
            "div",
            { staticClass: "col-md-3" },
            [
              _c("form-select", {
                attrs: {
                  label: _vm.Lang.get("messages.academic_year"),
                  options: _vm.academicYears,
                  name: "academicYear",
                  model: _vm.localFilters,
                  errors: _vm.formErrors,
                  "label-field": "name",
                  reduce: (value) => value.id,
                },
                on: {
                  change: (e) => {
                    _vm.clearInput("academicYear")
                    _vm.setEnrollment()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-3" },
        [
          _c("form-select", {
            attrs: {
              label: _vm.Lang.get("messages.stage"),
              options: _vm.stagesForSelect,
              name: "stageEnrollment",
              model: _vm.localFilters,
              errors: _vm.formErrors,
              "label-field": "name",
              reduce: (value) => value.id,
            },
            on: {
              change: function ($event) {
                return _vm.getYearLevels()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-3" },
        [
          _c("form-select", {
            attrs: {
              label: _vm.Lang.get("messages.yearLevel"),
              options: _vm.yearLevelForSelect,
              name: "yearLevelEnrollment",
              model: _vm.localFilters,
              errors: _vm.formErrors,
              "label-field": "name",
              reduce: (value) => value.id,
            },
            on: {
              change: (e) => {
                _vm.getClasses()
                _vm.updateSelectedNames()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-3" },
        [
          _c("form-select", {
            attrs: {
              label: _vm.Lang.get("messages.class"),
              options: _vm.classes,
              name: "classEnrollment",
              model: _vm.localFilters,
              errors: _vm.formErrors,
              "label-field": "name",
              reduce: (value) => value.id,
            },
            on: {
              change: (e) => {
                _vm.clearInput("class")
                _vm.updateSelectedNames()
                _vm.getStudents()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-3" },
        [
          _c("form-select", {
            attrs: {
              label: _vm.Lang.get("messages.student"),
              options: _vm.studentsForSelect,
              name: "student",
              model: _vm.localFilters,
              errors: _vm.formErrors,
              "label-field": "name",
              reduce: (value) => value.id,
            },
            on: {
              change: (e) => {
                _vm.clearInput("student")
                _vm.updateSelectedNames()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("custom"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }